import { LockOpenCheckOutlineIcon } from './LockOpenCheckOutlineIcon';

/**
 * author: Colton Wiscombe
 * id FA8CFB4F-319F-42BE-8615-B4FECDA27719
 * name lock-open-check-outline
 * version: 5.8.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lock-open-check-outline.svg
 * tags
 * - Lock 
 */
export const DecryptedCheckOutlineIcon = LockOpenCheckOutlineIcon;
export default DecryptedCheckOutlineIcon